import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
    margin: 'auto',
    padding: theme.spacing(4),
    textAlign: 'center',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4
  },
  iconContainer: {
    marginBottom: theme.spacing(2),
    '& svg': {
      fontSize: 80,
      color: theme.palette.success.main
    }
  },
  section: {
    marginTop: theme.spacing(4),
    textAlign: 'start'
  },
  link: {
    color: theme.palette.info.main,
    textDecoration: 'underline',
    cursor: 'pointer',
    marginTop: theme.spacing(2)
  }
}))
